import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CmsArticle, CmsCollection, CmsContentType, CmsPicture, CmsTeaser } from '@fcom/core-api';
import { StructurePageBlockType } from '@fcom/ond-marketing-landing-core';

@Component({
  selector: 'cms-marketing-activity-blocks',
  templateUrl: './cms-marketing-activity-blocks.component.html',
  styleUrls: ['./cms-marketing-activity-blocks.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsMarketingActivityBlocksComponent {
  content = input.required<CmsCollection<CmsTeaser | CmsArticle>>();

  readonly isDestinationPromotion = computed(
    () => this.content().localSettings?.blockType === StructurePageBlockType.DESTINATION_PROMOTION
  );

  mappedContent = computed(() => {
    const content = this.content();
    const isDestinationPromotion = this.isDestinationPromotion();
    const promotionButtonText: string | undefined = content.localSettings?.callToActionCustomText;

    return {
      ...content,
      teaserTitle: isDestinationPromotion ? undefined : content.teaserTitle,
      items: (content.items ?? []).map((item) => {
        const isTeaser = item.contentType === CmsContentType.CMTeaser;
        const firstMedia = isTeaser ? undefined : item.media?.[0];
        const mediaPicture =
          firstMedia?.contentType === CmsContentType.CMPicture ? (firstMedia as CmsPicture) : undefined;
        const linkText = isTeaser ? item.linkText : undefined;
        const hasLink = !isDestinationPromotion || Boolean(item.target?.url);

        return {
          ...item,
          picture: item.picture || mediaPicture,
          target: hasLink
            ? {
                ...item.target,
                title: isDestinationPromotion ? promotionButtonText : linkText,
              }
            : null,
        };
      }),
    };
  });
}
